import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessHours } from '../models/business-hours.model';
import { AuthEventType } from '../../auth/models/auth-event.model';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../../shared/user/user.service';
import { environment } from '../../../environments/environment';
var BusinessHoursService = /** @class */ (function () {
    function BusinessHoursService(_http, _auth, _userService, _errorHandler) {
        var _this = this;
        this._http = _http;
        this._auth = _auth;
        this._userService = _userService;
        this._errorHandler = _errorHandler;
        this._auth.authStream.subscribe(function (e) { return _this._onAuthEvent(e); });
    }
    BusinessHoursService.prototype._onAuthEvent = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!e) {
                            return [2 /*return*/];
                        }
                        _a = e.type;
                        switch (_a) {
                            case AuthEventType.SignIn: return [3 /*break*/, 1];
                            case AuthEventType.InvalidSignIn: return [3 /*break*/, 3];
                            case AuthEventType.SignOut: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        _b = this;
                        return [4 /*yield*/, this._userService.getUserInfo()];
                    case 2:
                        _b.userInfo = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.userInfo = null;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Method creates a new BusinessHour in the API Server via a post request with the business id and a business hours object.
    * @param businessId {number} used to identify the business
    * @param hours {BusinessHours} business hours object
    * @returns {Promise<BusinessHours>} API Server will respond with a new Business OBJ.
    */
    BusinessHoursService.prototype.createBusinessHours = function (businessId, hours) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR, URL, RESPONSE, BUSINESS_HOURS, ERROR, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.token || !this._auth.endUser) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/hours/";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.post(URL, hours).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        BUSINESS_HOURS = BusinessHours.parse(RESPONSE);
                        if (!BUSINESS_HOURS) {
                            ERROR = new Error('API did not return valid business hours object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            return [2 /*return*/, BUSINESS_HOURS];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Sends put request to api server to update a given businessHours.
    * Method updates the API Server with data from the json object with one field of note being passed in.
    * @param businessId {number} businessId
    * @param businessHourId {number} the id of the businessHours that will be updated
    * @param hours {BusinessHours} content to be updated.
    * @returns {Promise<BusinessHours>} API Server will respond with updated Business OBJ.
    */
    BusinessHoursService.prototype.updateBusinessHours = function (businessId, businessHourId, hours) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR, URL, RESPONSE, BUSINESS_HOURS, ERROR, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.token || !this._auth.endUser) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/hours/" + businessHourId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.put(URL, hours).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        BUSINESS_HOURS = BusinessHours.parse(RESPONSE);
                        if (!BUSINESS_HOURS) {
                            ERROR = new Error('API did not return valid business hours object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            return [2 /*return*/, BUSINESS_HOURS];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this._errorHandler.handleError(e_2);
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Method to call API to delete a business hours from a business
    * Requires that user is a flight deck admin to delete notes
    * @param businessId {number} the business to remove the admin from.
    * @param businessHourId {number} the specific business hour to be deleted.
    * @returns {Promise<string>} Returns SUCCESS or error message for display to user.
    */
    BusinessHoursService.prototype.deleteBusinessHours = function (businessId, businessHourId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR, URL, RESPONSE, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.token || !this._auth.endUser) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + businessId + "/hours/" + businessHourId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.delete(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        return [2 /*return*/, true];
                    case 3:
                        e_3 = _a.sent();
                        this._errorHandler.handleError(e_3);
                        throw false;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return BusinessHoursService;
}());
export { BusinessHoursService };
